import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const CalendarViewPage = lazy(() => import('./pages/CalendarViewPage'));
const EventTypesPage = lazy(() => import('./pages/EventTypesPage'));
const BookingsPage = lazy(() => import('./pages/BookingsPage'));
const AvailabilityPage = lazy(() => import('./pages/AvailabilityPage'));
const CalDavSyncPage = lazy(() => import('./pages/CalDavSyncPage'));
const PublicBookingPage = lazy(() => import('./pages/PublicBookingPage'));

export const CalendarRoutes: RouteObject = {
  path: 'calendar',
  element: <ModuleGuard moduleId="core.calendar" />,
  children: [
    { path: 'view', element: <CalendarViewPage />, handle: { crumb: 'Calendar Workspace' } },
    { path: 'event-types', element: <EventTypesPage />, handle: { crumb: 'Event Types' } },
    { path: 'bookings', element: <BookingsPage />, handle: { crumb: 'Appointments' } },
    { path: 'availability', element: <AvailabilityPage />, handle: { crumb: 'Working Hours' } },
    { path: 'sync', element: <CalDavSyncPage />, handle: { crumb: 'CalDAV Sync' } },
    { path: 'book/:eventSlug', element: <PublicBookingPage />, handle: { crumb: 'Book Appointment' } },
  ],
};

export default CalendarRoutes;
